import React, { useEffect, useState } from 'react'
import { Alert, Button, Stack, Typography } from '@mui/material'
import {
  softDeleteExpiredDemos,
  getExpiredDemoCount,
} from 'shared/api/mutations'

export default function DeleteExpiredDemo() {
  const [errorMessage, setErrorMessage] = useState('')
  const [message, setMessage] = useState('')
  const [expiredDemoCount, setExpiredDemoCount] = useState(0)

  const fetchExpiredDemoCount = async () => {
    const res = await getExpiredDemoCount()

    if (res.errors) {
      setErrorMessage('There was an error getting count of expired demos.')
    } else {
      setExpiredDemoCount(res.data)
    }
  }

  // Fetch expired demos count on component mount
  useEffect(() => {
    fetchExpiredDemoCount()
  }, [])

  const softDeleteExpiredDemosOnClick = async () => {
    const res = await softDeleteExpiredDemos()

    if (res.errors) {
      setErrorMessage('There was an error deleting expired demos.')
    } else {
      setMessage(res.data)
      errorMessage !== '' && setErrorMessage('')
      // Refresh count after deletion
      fetchExpiredDemoCount()
    }
  }

  return (
    <>
      {/* Layout: Count (left) | Button (right) */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
      >
        <Typography variant="h6">
          Total Count of Expired Demos: {expiredDemoCount}
        </Typography>
        <Button
          variant="outlined"
          onClick={softDeleteExpiredDemosOnClick}
          disabled={expiredDemoCount === 0} // Disable button if count is 0
        >
          Soft Delete Expired Demos
        </Button>
      </Stack>

      {/* Display alerts */}
      {errorMessage && (
        <Alert severity="error" onClose={() => setErrorMessage('')}>
          {errorMessage}
        </Alert>
      )}

      {message && (
        <Alert severity="success" onClose={() => setMessage('')}>
          {message}
        </Alert>
      )}
    </>
  )
}
